<template>
  <div v-if="version === 'v1'" class="n-blog-card shine-effect tw-group">
    <nuxt-link :to="`/blogs/${blog.url}`" :external="true" class="tw-inline-block !tw-p-0">
      <div class="tw-relative">
        <library-image :src="blog.image" :title="blog.title" :alt="blog.title" :w-ratio="16" :h-ratio="9" />
        <div
          class="shine tw-absolute tw-inset-0 tw-bg-black tw-opacity-0 tw-transition-opacity tw-duration-500 group-hover:tw-opacity-20"
          style="border-radius: var(--rounded)"
        ></div>
      </div>
      <h6>{{ blog.title }}</h6>
      <p>{{ blog.description }}</p>
    </nuxt-link>
  </div>

  <div v-if="version === 'v2'" class="n-blog-card shine-effect tw-group">
    <nuxt-link :to="`/blogs/${blog.url}`" :external="true" class="tw-inline-block !tw-p-0">
      <div class="tw-relative">
        <library-image :src="blog.image" :title="blog.title" :alt="blog.title" :w-ratio="16" :h-ratio="9" />
        <div
          class="shine tw-absolute tw-inset-0 tw-bg-black tw-opacity-0 tw-transition-opacity tw-duration-500 group-hover:tw-opacity-20"
          style="border-radius: var(--rounded)"
        ></div>
      </div>
      <h6>{{ blog.title }}</h6>
      <p>{{ blog.description }}</p>
    </nuxt-link>
  </div>

  <div v-if="version === 'v3'" class="n-blog-card shine-effect tw-group">
    <nuxt-link :to="`/blogs/${blog.url}`" :external="true" class="tw-inline-block !tw-p-0">
      <div class="tw-relative">
        <library-image :src="blog.image" :title="blog.title" :alt="blog.title" :w-ratio="16" :h-ratio="9" />
        <div
          class="shine tw-absolute tw-inset-0 tw-bg-black tw-opacity-0 tw-transition-opacity tw-duration-500 group-hover:tw-opacity-20"
          style="border-radius: var(--rounded)"
        ></div>
      </div>
      <h3 class="tw-mb-4 tw-mt-4 tw-line-clamp-2 tw-h-[70px] tw-uppercase">{{ blog.title }}</h3>
      <p>{{ blog.description }}</p>
    </nuxt-link>
  </div>

  <div v-if="version === 'v4'" class="n-blog-card shine-effect tw-group">
    <nuxt-link :to="`/blogs/${blog.url}`" :external="true" class="tw-inline-block !tw-p-0">
      <div class="tw-relative">
        <library-image :src="blog.image" :title="blog.title" :alt="blog.title" :w-ratio="16" :h-ratio="9" />
        <div
          class="shine tw-absolute tw-inset-0 tw-bg-black tw-opacity-0 tw-transition-opacity tw-duration-500 group-hover:tw-opacity-20"
          style="border-radius: var(--rounded)"
        ></div>
      </div>
      <h3 class="tw-mb-4 tw-mt-4 tw-line-clamp-2 tw-h-[70px] ">{{ blog.title }}</h3>
      <p>{{ blog.description }}</p>
    </nuxt-link>
  </div>
</template>

<script lang="ts">
import { ComponentMixin } from '~/mixins/component.mixin';

export default defineNuxtComponent({
  name: 'Theme6BlogCard',

  mixins: [ComponentMixin],

  props: {
    blog: {
      required: true,
    },
    index: {
      required: true,
      type: Number,
    },
    version: {
      type: String,
      default: 'v1',
    },
  },

  computed: {
    ROUTES() {
      return ROUTES;
    },
  },
});
</script>
